import React, { Component } from "react";
import BotonAyudaManuales from "../../../../Components/BotonAyudaManuales";
import { message, notification, Modal, Row, Col, PageHeader, Spin, Alert, Select, Divider, Table, Tag, Tooltip } from "antd";
import {
  ArrowLeftOutlined,
  DeleteOutlined,
  PlusOutlined,
  StopOutlined,
  ToolOutlined,
  CheckCircleOutlined,
  FilePdfOutlined,
  UndoOutlined,
  SwapOutlined,
} from "@ant-design/icons";
import axios from "axios";
import moment from "moment";
import { connect } from "react-redux";
import { createPortal } from "react-dom";
import { DndContext, DragOverlay, PointerSensor, pointerWithin } from "@dnd-kit/core";
import DynamicCardForm from "../../../../Components/DynamicCardForm";
import { ButtonItem, ModalItem, Form, FormItem, InputItem, InputNumberItem, TextAreaItem, ErrorItem, NotificacionMovimientosInventario, round2Decimals, MensajeError, SelectItem, DatePickerItem } from "../../../../Components/Items";
import SelectInsumosItem from "../../../../Components/SelectInsumosItem";
import ElegirMarbetes from "../../Marbetes/ElegirMarbetes/ElegirMarbetes";
import ElegirLotes from "../../LotesCaducidades/ElegirLotes/ElegirLotes";
import { iconoDeEtapa, colorDeEtapa } from "../EtapasOrdenProduccionPU/etapaVisual.utils";
import ColumnaEtapaOrdenPU, { ColumnaEtapaOrdenPUArrastrable, TarjetaProductoEtapaPU } from "./ColumnaEtapaOrdenPU";
import ModalCancelarOrdenPU from "./ModalCancelarOrdenPU";
import ModalSobrantesCierreOrdenPU from "./ModalSobrantesCierreOrdenPU";
import ModalConfirmarSobrantesMoverPU from "./ModalConfirmarSobrantesMoverPU";
import ModalReabrirOrdenPU from "./ModalReabrirOrdenPU";
import ModalPdfCierreOrdenPU from "./ModalPdfCierreOrdenPU";
import ModalPdfOrdenMaquila from "./ModalPdfOrdenMaquila";
import ModalConfirmarSolicitarMaterialPU from "./ModalConfirmarSolicitarMaterialPU";
import { unidadAMinutos } from "../OrdenesDeProduccionPU/PlaneacionProduccionPU/planeacion.utils";
import TrazabilidadOrdenPU from "./TrazabilidadOrdenPU";
import TabbedDynamicTable from "../../../../Components/TabbedDynamicTable";

const { Option } = Select;

const faltanteDe = (renglon) => Math.max(0, Math.round((renglon.cantidad - renglon.consumido) * 100) / 100);

const SENSORES_TABLERO = [{ sensor: PointerSensor, options: { activationConstraint: { distance: 8 } } }];

class VistaOrdenDeProduccionPU extends Component {
  state = {
    loading: false,
    orden: null,
    etapas: [],
    motivosPorEtapa: {},
    defaultsProduccion: {},

    modalMoverVisible: false,
    etapaOrigen: null,
    destinos: [],
    operadorId: null,
    maquinaria: "",
    minutosTrabajo: null,
    lotesPorInsumo: {},
    fechaMovimiento: null,

    modalElegirVisible: false,
    modalElegirTipo: null, // "marbetes" | "lotes"
    insumoActivo: null,

    modalCancelarVisible: false,
    modalReabrirVisible: false,
    modalSolicitarVisible: false,
    solicitarEtapa: null,
    solicitarPendientes: [],
    solicitarObservaciones: "",
    solicitarInsumosPorMatriz: {},
    solicitarCantidadesEditadas: {},
    solicitarCantidadAProducir: 0,
    solicitarInsumosCargando: false,
    inventarioOrden: [],
    sobrantesDisponibles: [],
    modalSobrantesVisible: false,
    sobrantesPendientes: [],
    modalConfirmarSobrantesMoverVisible: false,
    faltantesMover: [],
    modalPdfCierreVisible: false,
    recargarTrazabilidad: 0,
    etapaArrastradaId: null,
    etapaEncimaId: null,
  };

  get ordenId() {
    return this.props.ordenIdEmbebido || this.props.location?.state?.id;
  }

  componentDidMount() {
    if (!this.ordenId) return;
    this.cargarOrden();
    this.cargarInventarioOrden();
    window.addEventListener("material_orden_actualizado", this.onMaterialOrdenActualizado);
  }

  componentWillUnmount() {
    window.removeEventListener("material_orden_actualizado", this.onMaterialOrdenActualizado);
  }

  onMaterialOrdenActualizado = (event) => {
    const data = event.detail || {};
    if (!data.ordenId || data.ordenId.toString() !== this.ordenId?.toString()) return;

    notification.info({
      message: data.tipo === "traspaso" ? "Almacén traspasó material a tu orden" : "Almacén generó una requisición para tu orden",
      description: data.mensaje || "",
    });
    this.cargarOrden();
    this.cargarInventarioOrden();
  };

  cargarInventarioOrden = () => {
    axios
      .post("ordenesDeProduccionPU/inventarioOrden", { ordenId: this.ordenId, empresaId: this.props.empresaId }, { headers: this.props.headersToken })
      .then((res) => {
        if (res.data.success === 2) {
          this.setState({ inventarioOrden: res.data.insumos || [], sobrantesDisponibles: res.data.sobrantesDisponibles || [] });
        }
      })
      .catch(() => {});
  };

  filaDestinoVacia = () => ({
    etapaDestinoId: null,
    cantidad: null,
    observaciones: "",
    responsableId: this.props.usuarioId,
    motivoEntradaId: null,
    insumoScrapId: this.state.defaultsProduccion.insumoScrap?._id || null,
    insumoRetrabajoId: this.state.defaultsProduccion.matrizRetrabajo?._id || null,
    insumoTerminadoId:
      this.state.defaultsProduccion.insumoTerminado?._id || this.state.orden?.insumoRelacionadoId?._id || this.state.orden?.insumoRelacionadoId || null,
    calidadAprobadorId: this.props.usuarioId,
    calidadComentario: "",
    comentarioEntrada: "",
  });

  cargarOrden = () => {
    this.setState({ loading: true });
    axios
      .post("ordenesDeProduccionPU/verOrden", { ordenId: this.ordenId, empresaId: this.props.empresaId }, { headers: this.props.headersToken })
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          this.setState(
            { orden: res.data.orden, etapas: res.data.etapas || [], defaultsProduccion: res.data.defaultsProduccion || {} },
            this.abrirMovimientoSolicitado
          );
          this.cargarMotivos(res.data.orden?.flujoId?._id || res.data.orden?.flujoId);
        } else {
          MensajeError({ message: res.data.error || "No se pudo cargar la orden" });
        }
      })
      .catch(() => {
        this.setState({ loading: false });
        MensajeError({ message: "Error al conectar con el servidor" });
      });
  };

  cargarMotivos = (flujoId) => {
    if (!flujoId) return;
    axios
      .post(
        "motivosEtapaOrdenProduccionPU/motivosPorFlujo",
        { empresaId: this.props.empresaId, flujoId, soloActivos: true },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success !== 2) return;
        const motivosPorEtapa = {};
        (res.data.motivos || []).forEach((motivo) => {
          if (!motivosPorEtapa[motivo.etapaId]) motivosPorEtapa[motivo.etapaId] = [];
          motivosPorEtapa[motivo.etapaId].push(motivo);
        });
        Object.values(motivosPorEtapa).forEach((lista) => lista.sort((a, b) => (a.orden || 0) - (b.orden || 0)));
        this.setState({ motivosPorEtapa });
      })
      .catch(() => {});
  };

  motivosDeEtapa = (etapaId) => (etapaId && this.state.motivosPorEtapa[etapaId]) || [];

  abrirModalCancelar = () => this.setState({ modalCancelarVisible: true });
  cerrarModalCancelar = () => this.setState({ modalCancelarVisible: false });
  onOrdenCancelada = () => {
    this.cerrarModalCancelar();
    this.cargarOrden();
  };

  abrirModalReabrir = () => this.setState({ modalReabrirVisible: true });
  cerrarModalReabrir = () => this.setState({ modalReabrirVisible: false });
  onOrdenReabierta = () => {
    this.cerrarModalReabrir();
    this.cargarOrden();
  };

  cerrarModalPdfCierre = () => this.setState({ modalPdfCierreVisible: false });

  piezasResueltas = () => {
    const { orden, etapas } = this.state;
    if (!orden) return 0;
    const etapaPorId = new Map(etapas.map((e) => [e._id, e]));
    const enTerminalesODefectuosas = (orden.avancePorEtapa || []).reduce((acc, a) => {
      const etapa = etapaPorId.get(a.etapaId?._id || a.etapaId);
      return etapa && (etapa.esFinal || etapa.esDefectuoso) ? round2Decimals(acc + (a.cantidad || 0)) : acc;
    }, 0);
    return round2Decimals(enTerminalesODefectuosas + (orden.piezasEnviadasARetrabajo || 0));
  };

  ordenCompletada = () => {
    const { orden } = this.state;
    return !!orden && this.piezasResueltas() >= orden.cantidadEsperada;
  };

  piezasFaltantes = () => {
    const { orden } = this.state;
    return orden ? Math.max(0, round2Decimals(orden.cantidadEsperada - this.piezasResueltas())) : 0;
  };

  piezasEnProceso = () => {
    const { orden, etapas } = this.state;
    if (!orden) return [];
    const etapaPorId = new Map(etapas.map((e) => [e._id, e]));
    return (orden.avancePorEtapa || [])
      .map((a) => ({ etapa: etapaPorId.get(a.etapaId?._id || a.etapaId), cantidad: a.cantidad || 0 }))
      .filter(({ etapa, cantidad }) => etapa && !etapa.esInicial && !etapa.esFinal && !etapa.esDefectuoso && !etapa.esRetrabajo && cantidad > 0);
  };

  terminarOrden = () => {
    const enProceso = this.piezasEnProceso();
    if (enProceso.length > 0) {
      const terminales = this.state.etapas
        .filter((e) => e.esFinal || e.esDefectuoso || e.esRetrabajo)
        .map((e) => (e.nombre || "").trim())
        .join(", ");
      Modal.warning({
        title: "Hay piezas en proceso",
        content: `No se puede cerrar la orden: ${enProceso.map(({ etapa, cantidad }) => `${cantidad} en ${(etapa.nombre || "").trim()}`).join(", ")}. Muévelas a ${terminales}.`,
        okText: "Entendido",
      });
      return;
    }
    const faltantes = this.piezasFaltantes();
    if (faltantes > 0) {
      Modal.confirm({
        title: "Cerrar la orden con faltante",
        content: `Faltan ${faltantes} pieza(s) por resolver. La orden se cerrará como incumplida y esas piezas quedarán registradas como no producidas.`,
        okText: "Cerrar con faltante",
        cancelText: "Cancelar",
        onOk: () => this.revisarSobrantes(),
      });
      return;
    }
    this.revisarSobrantes();
  };

  revisarSobrantes = () => {
    this.setState({ loading: true });
    axios
      .post("ordenesDeProduccionPU/sobrantesAlTerminar", { ordenId: this.ordenId, empresaId: this.props.empresaId }, { headers: this.props.headersToken })
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success !== 2) {
          MensajeError({ message: res.data.error || "No se pudo revisar el material sobrante de la orden" });
          return;
        }
        if ((res.data.sobrantes || []).length === 0) {
          this.confirmarCierreOrden([]);
        } else {
          this.setState({ modalSobrantesVisible: true, sobrantesPendientes: res.data.sobrantes });
        }
      })
      .catch(() => {
        this.setState({ loading: false });
        MensajeError({ message: "Error al conectar con el servidor" });
      });
  };

  cerrarModalSobrantes = () => this.setState({ modalSobrantesVisible: false, sobrantesPendientes: [] });

  confirmarCierreOrden = (sobrantesReales) => {
    this.setState({ loading: true, modalSobrantesVisible: false });
    axios
      .post(
        "ordenesDeProduccionPU/cerrarOrden",
        { ordenId: this.ordenId, empresaId: this.props.empresaId, usuarioId: this.props.usuarioId, sobrantesReales, aceptarFaltante: true },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success("Orden marcada como terminada");
          (res.data.avisos || []).forEach((aviso) => message.warning(aviso, 8));
          this.setState({ orden: res.data.orden, modalPdfCierreVisible: true, sobrantesPendientes: [] });
        } else {
          MensajeError({ message: res.data.error || "No se pudo terminar la orden" });
        }
      })
      .catch(() => {
        this.setState({ loading: false });
        MensajeError({ message: "Error al conectar con el servidor" });
      });
  };

  cantidadEnEtapa = (etapaId) => this.state.orden?.avancePorEtapa?.find((l) => (l.etapaId?._id || l.etapaId) === etapaId)?.cantidad || 0;

  productoDeOrden = () => {
    const { orden } = this.state;
    const insumo = orden?.insumoRelacionadoId;
    if (insumo?.descripcion) return `${insumo.clave ? insumo.clave + " - " : ""}${insumo.descripcion}`;
    return orden?.partidaSnapshot?.nombre || (orden?.matrices || []).map((m) => m.matrizId?.descripcion || m.descripcion).filter(Boolean).join(", ");
  };

  enviadosARetrabajo = (etapa) =>
    etapa.esRetrabajo ? (this.state.orden?.enviosARetrabajo || []).filter((e) => (e.etapaId?._id || e.etapaId)?.toString() === etapa._id?.toString()) : [];

  piezasQueSeMueven = () =>
    (this.state.orden?.matrices || [])
      .map((m) => {
        const clave = m.matrizId?.clave || m.clave;
        const descripcion = m.matrizId?.descripcion || m.descripcion;
        return descripcion ? `${clave ? clave + " - " : ""}${descripcion}` : null;
      })
      .filter(Boolean)
      .join(", ") || this.productoDeOrden();

  piezasPasadasPorEtapa = (etapa) => {
    const { orden } = this.state;
    if (etapa.esInicial) return orden?.cantidadEsperada || 0;
    return orden?.piezasPasadasPorEtapa?.[etapa._id?.toString()] || 0;
  };

  renglonesConsumoDeEtapa = (etapaId) => {
    const { orden } = this.state;
    if (!orden) return [];
    return (orden.consumos || [])
      .filter((c) => (c.etapaId?._id || c.etapaId).toString() === etapaId.toString())
      .map((c) => {
        const matriz = (orden.matrices || []).find((m) => (m.matrizId?._id || m.matrizId).toString() === (c.matrizId?._id || c.matrizId).toString());
        const matrizNombre = matriz ? `${matriz.clave ? matriz.clave + " - " : ""}${matriz.descripcion || ""}` : "—";
        return { matrizId: c.matrizId?._id || c.matrizId, matrizNombre, cantidad: c.cantidad, consumido: c.consumido || 0 };
      });
  };

  cantidadTotalDestinos = () => this.state.destinos.reduce((acc, d) => acc + (Number(d.cantidad) || 0), 0);

  renderInsumoConDefault = (index, destino, campo, insumoDefault, propsSelect) => {
    const nombre = (insumo) => `${insumo.clave ? insumo.clave + " - " : ""}${insumo.descripcion || ""}`;
    const usaDefault = insumoDefault && destino[campo] === insumoDefault._id && !destino.cambiando?.[campo];
    if (usaDefault) {
      return (
        <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
          <div style={{ flex: 1 }}>
            <InputItem disabled value={nombre(insumoDefault)} />
          </div>
          <Tooltip title="Usar otro solo en este movimiento">
            <ButtonItem type="default" size="small" cyan icon={<SwapOutlined />} onClick={() => this.cambiarDestino(index, { cambiando: { ...destino.cambiando, [campo]: true } })} />
          </Tooltip>
        </div>
      );
    }
    return (
      <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
        <div style={{ flex: 1 }}>
          <SelectInsumosItem
            empresaId={this.props.empresaId}
            headersToken={this.props.headersToken}
            width="100%"
            {...propsSelect}
            value={destino[campo] || undefined}
            onChange={(valor) => this.cambiarDestino(index, { [campo]: valor })}
          />
        </div>
        {insumoDefault && (
          <Tooltip title={`Volver al default: ${nombre(insumoDefault)}`}>
            <ButtonItem
              type="default"
              size="small"
              blanco
              icon={<UndoOutlined />}
              onClick={() => this.cambiarDestino(index, { [campo]: insumoDefault._id, cambiando: { ...destino.cambiando, [campo]: false } })}
            />
          </Tooltip>
        )}
      </div>
    );
  };

  renderUsuarioActual = (etiqueta) => (
    <FormItem label={etiqueta} required margin labelCol={{ span: 24 }} wrapperCol={{ span: 24 }}>
      <InputItem disabled value={this.props.nombreUsuario} />
    </FormItem>
  );

  comparativoMaterial = () => {
    const { orden } = this.state;
    if (!orden) return [];

    return (orden.consumos || []).map((c, indice) => {
      const matriz = (orden.matrices || []).find((m) => (m.matrizId?._id || m.matrizId).toString() === (c.matrizId?._id || c.matrizId).toString());
      const etapa = c.etapaId;
      const planeado = c.cantidad || 0;
      const real = c.consumido || 0;

      const hijos = (matriz?.especificaciones || []).map((esp) => {
        const insumo = esp.insumoId;
        const planeadoInsumo = round2Decimals((esp.cantidad || 0) * planeado);
        const realInsumo = round2Decimals((esp.cantidad || 0) * real);
        return {
          key: `${indice}-${(insumo?._id || insumo)}`,
          concepto: `${insumo?.clave ? insumo.clave + " - " : ""}${insumo?.descripcion || "Insumo"}`,
          unidad: insumo?.unidadId?.nombre || "",
          porUnidad: esp.cantidad,
          planeado: planeadoInsumo,
          real: realInsumo,
          diferencia: round2Decimals(planeadoInsumo - realInsumo),
        };
      });

      return {
        key: `matriz-${indice}`,
        esMatriz: true,
        concepto: `${matriz?.clave ? matriz.clave + " - " : ""}${matriz?.descripcion || "Matriz"}`,
        unidad: matriz?.unidad || "",
        etapa,
        planeado,
        real,
        diferencia: round2Decimals(planeado - real),
        children: hijos.length > 0 ? hijos : undefined,
      };
    });
  };

  abrirModalMover = (etapa, destinoInicial) => {
    this.setState({
      modalMoverVisible: true,
      etapaOrigen: etapa,
      destinos: [{ ...this.filaDestinoVacia(), ...destinoInicial }],
      fechaMovimiento: moment(),
      operadorId: this.props.usuarioId,
      maquinaria: "",
      minutosTrabajo: null,
      lotesPorInsumo: {},
    });
  };

  cerrarModalMover = () =>
    this.setState({ modalMoverVisible: false, etapaOrigen: null }, () => this.props.onCerrarEmbebido && this.props.onCerrarEmbebido());

  arbolConInventarioProyecto = (nodos) => {
    const { inventarioOrden } = this.state;
    return (nodos || []).map((nodo) => {
      if (nodo.esMatriz) {
        return { ...nodo, children: this.arbolConInventarioProyecto(nodo.children) };
      }
      const infoInventario = inventarioOrden.find((i) => i.insumoId === nodo.insumoId);
      return {
        ...nodo,
        unidad: nodo.unidad || infoInventario?.unidad || "",
        cantidadPorPieza: nodo.cantidadPorUnidad || 0,
        inventarioProyecto: infoInventario?.inventarioProyecto || 0,
      };
    });
  };

  aplanarInsumosHoja = (nodos, acumulador = []) => {
    (nodos || []).forEach((nodo) => {
      if (nodo.esMatriz) {
        this.aplanarInsumosHoja(nodo.children, acumulador);
      } else {
        acumulador.push(nodo);
      }
    });
    return acumulador;
  };

  abrirConfirmarSolicitar = (etapa, pendientes) => {
    if (!pendientes || pendientes.length === 0) return;

    const faltanteMinimo = Math.min(...pendientes.map((renglon) => faltanteDe(renglon)));

    this.setState({
      modalSolicitarVisible: true,
      solicitarEtapa: etapa,
      solicitarPendientes: pendientes,
      solicitarObservaciones: "",
      solicitarInsumosExtra: [],
      solicitarInsumosPorMatriz: {},
      solicitarCantidadesEditadas: {},
      solicitarCantidadAProducir: faltanteMinimo,
      solicitarInsumosCargando: true,
    });

    axios
      .post("almacen/detalleInsumosOrden", { ordenId: this.ordenId, empresaId: this.props.empresaId }, { headers: this.props.headersToken })
      .then((res) => {
        if (res.data.success !== 2) {
          this.setState({ solicitarInsumosCargando: false });
          return;
        }
        const porMatriz = {};
        pendientes.forEach((renglon) => {
          const grupo = (res.data.matrices || []).find(
            (m) => m.matrizId === renglon.matrizId?.toString() && m.etapaId === etapa._id?.toString()
          );
          porMatriz[renglon.matrizId] = this.aplanarInsumosHoja(this.arbolConInventarioProyecto(grupo?.insumos || []));
        });
        this.setState({ solicitarInsumosPorMatriz: porMatriz, solicitarInsumosCargando: false }, () =>
          this.recalcularCantidadesSolicitar(faltanteMinimo)
        );
      })
      .catch(() => this.setState({ solicitarInsumosCargando: false }));
  };

  recalcularCantidadesSolicitar = (cantidadAProducir) => {
    const { solicitarPendientes: pendientes, solicitarInsumosPorMatriz: porMatriz } = this.state;
    const cantidadesPorMatriz = {};
    (pendientes || []).forEach((renglon) => {
      const cantidadEfectiva = this.cantidadPiezasSolicitar(cantidadAProducir, renglon);
      const cantidades = {};
      (porMatriz[renglon.matrizId] || []).forEach((insumo) => {
        cantidades[insumo.insumoId] = round2Decimals((insumo.cantidadPorPieza || 0) * cantidadEfectiva);
      });
      cantidadesPorMatriz[renglon.matrizId] = cantidades;
    });
    this.setState({ solicitarCantidadAProducir: cantidadAProducir, solicitarCantidadesEditadas: cantidadesPorMatriz });
  };

  onChangeCantidadInsumoSolicitar = (matrizId, insumoId, valor) => {
    this.setState((prev) => ({
      solicitarCantidadesEditadas: {
        ...prev.solicitarCantidadesEditadas,
        [matrizId]: { ...prev.solicitarCantidadesEditadas[matrizId], [insumoId]: valor },
      },
    }));
  };

  cerrarConfirmarSolicitar = () =>
    this.setState({
      modalSolicitarVisible: false,
      solicitarEtapa: null,
      solicitarPendientes: [],
      solicitarObservaciones: "",
      solicitarInsumosPorMatriz: {},
      solicitarCantidadesEditadas: {},
      solicitarCantidadAProducir: 0,
      solicitarInsumosCargando: false,
    });

  cantidadPiezasSolicitar = (cantidadAProducir, renglon) =>
    this.state.orden?.tipoLista === "abierta" ? cantidadAProducir || 0 : Math.min(cantidadAProducir || 0, faltanteDe(renglon));

  confirmarSolicitarTodoDeEtapa = async () => {
    const {
      solicitarEtapa: etapa,
      solicitarPendientes: pendientes,
      solicitarObservaciones: observaciones,
      solicitarCantidadesEditadas,
      solicitarCantidadAProducir,
      solicitarInsumosExtra,
    } = this.state;
    if (!pendientes || pendientes.length === 0) return;
    if (!(solicitarCantidadAProducir > 0)) {
      MensajeError({ message: "Captura una cantidad a producir mayor a 0" });
      return;
    }
    if ((solicitarInsumosExtra || []).some((i) => !i.insumoId || !(i.cantidad > 0))) {
      MensajeError({ message: "Cada insumo fuera de lista necesita un insumo elegido y una cantidad mayor a 0" });
      return;
    }
    const renglonesAEnviar = pendientes.filter((renglon) => this.cantidadPiezasSolicitar(solicitarCantidadAProducir, renglon) > 0);
    if (renglonesAEnviar.length === 0) {
      MensajeError({ message: "No hay nada pendiente por solicitar en esta etapa" });
      return;
    }
    this.setState({ loading: true });

    let error = null;
    for (const [indice, renglon] of renglonesAEnviar.entries()) {
      try {
        const insumosSolicitados = Object.entries(solicitarCantidadesEditadas[renglon.matrizId] || {})
          .filter(([, cantidad]) => cantidad > 0)
          .map(([insumoId, cantidad]) => ({ insumoId, cantidad }));
        const cantidadPiezas = this.cantidadPiezasSolicitar(solicitarCantidadAProducir, renglon);

        const res = await axios.post(
          "ordenesDeProduccionPU/solicitarMaterialEtapa",
          {
            empresaId: this.props.empresaId,
            usuarioId: this.props.usuarioId,
            ordenId: this.ordenId,
            matrizId: renglon.matrizId,
            etapaId: etapa._id,
            cantidadPiezas,
            observaciones,
            insumosExtra:
              indice === 0 ? (solicitarInsumosExtra || []).map((i) => ({ insumoId: i.insumoId, cantidad: i.cantidad })) : [],
            insumosSolicitados,
          },
          { headers: this.props.headersToken }
        );
        if (res.data.success !== 2) {
          error = res.data.error || `No se pudo solicitar ${renglon.matrizNombre}`;
          break;
        }
      } catch (e) {
        error = "Error al conectar con el servidor";
        break;
      }
    }

    this.setState({ loading: false });
    if (error) {
      MensajeError({ message: error });
    } else {
      message.success("Solicitud enviada a Almacén");
      this.cerrarConfirmarSolicitar();
    }
    this.cargarOrden();
  };

  agregarDestino = () => this.setState((prev) => ({ destinos: [...prev.destinos, this.filaDestinoVacia()] }));
  cambiarDestino = (index, cambios) =>
    this.setState((prev) => ({ destinos: prev.destinos.map((d, i) => (i === index ? { ...d, ...cambios } : d)) }));
  eliminarDestino = (index) => this.setState((prev) => ({ destinos: prev.destinos.filter((_, i) => i !== index) }));

  insumosConLotePorDestinos = () => {
    const { orden, destinos } = this.state;
    if (!orden) return [];
    const etapaDestinoIds = new Set(destinos.map((d) => d.etapaDestinoId && d.etapaDestinoId.toString()).filter(Boolean));
    const matrizPorId = new Map((orden.matrices || []).map((m) => [(m.matrizId?._id || m.matrizId).toString(), m]));
    const insumosMap = new Map();

    (orden.consumos || []).forEach((c) => {
      const etapaId = (c.etapaId?._id || c.etapaId).toString();
      if (!etapaDestinoIds.has(etapaId)) return;
      const matriz = matrizPorId.get((c.matrizId?._id || c.matrizId).toString());
      (matriz?.especificaciones || []).forEach((esp) => {
        const insumo = esp.insumoId;
        if (insumo && (insumo.marbetes || insumo.lotesCaducidades)) insumosMap.set(insumo._id, insumo);
      });
    });

    return [...insumosMap.values()];
  };

  estimarCantidadInsumo = (insumoId) => {
    const { orden, destinos } = this.state;
    let total = 0;
    destinos.forEach((destino) => {
      if (!destino.etapaDestinoId || !destino.cantidad) return;
      const cantidadBuena = Number(destino.cantidad) || 0;
      if (cantidadBuena <= 0) return;
      (orden.consumos || []).forEach((c) => {
        const etapaId = (c.etapaId?._id || c.etapaId).toString();
        if (etapaId !== destino.etapaDestinoId.toString()) return;
        const porPieza = orden.cantidadEsperada > 0 ? c.cantidad / orden.cantidadEsperada : 0;
        const unidades = round2Decimals(cantidadBuena * porPieza);
        if (unidades <= 0) return;
        const matriz = (orden.matrices || []).find((m) => (m.matrizId?._id || m.matrizId).toString() === (c.matrizId?._id || c.matrizId).toString());
        const esp = (matriz?.especificaciones || []).find((e) => (e.insumoId?._id || e.insumoId).toString() === insumoId.toString());
        if (esp) total += round2Decimals(esp.cantidad * unidades);
      });
    });
    return round2Decimals(total);
  };

  abrirElegirLote = (insumo) => {
    this.setState({
      modalElegirVisible: true,
      modalElegirTipo: insumo.marbetes ? "marbetes" : "lotes",
      insumoActivo: insumo,
    });
  };

  cerrarElegirLote = (seleccion) => {
    const insumo = this.state.insumoActivo;
    if (insumo && seleccion) {
      const clave = this.state.modalElegirTipo === "marbetes" ? "marbetes" : "lotes";
      this.setState((prev) => ({
        lotesPorInsumo: { ...prev.lotesPorInsumo, [insumo._id]: { ...(prev.lotesPorInsumo[insumo._id] || {}), [clave]: seleccion } },
      }));
    }
    this.setState({ modalElegirVisible: false, modalElegirTipo: null, insumoActivo: null });
  };

  desgloseMovimientoPorMatriz = () => {
    const { orden, destinos, etapas } = this.state;
    if (!orden) return [];
    const grupos = new Map();
    destinos.forEach((destino) => {
      if (!destino.etapaDestinoId || !destino.cantidad) return;
      const cantidadBuena = Number(destino.cantidad) || 0;
      if (cantidadBuena <= 0) return;
      (orden.consumos || []).forEach((c) => {
        const etapaId = (c.etapaId?._id || c.etapaId).toString();
        if (etapaId !== destino.etapaDestinoId.toString()) return;
        const porPieza = orden.cantidadEsperada > 0 ? c.cantidad / orden.cantidadEsperada : 0;
        const matrizId = (c.matrizId?._id || c.matrizId).toString();
        const matriz = (orden.matrices || []).find((m) => (m.matrizId?._id || m.matrizId).toString() === matrizId);
        const clave = `${matrizId}_${etapaId}`;
        if (!grupos.has(clave)) {
          const etapa = (etapas || []).find((e) => e._id?.toString() === etapaId);
          grupos.set(clave, {
            clave,
            matrizNombre: matriz ? `${matriz.clave ? matriz.clave + " - " : ""}${matriz.descripcion || ""}` : "—",
            etapaNombre: etapa?.nombre || c.etapaId?.nombre || "",
            unidadMatriz: matriz?.unidad || "",
            porPieza: round2Decimals(porPieza),
            piezas: 0,
            especificaciones: matriz?.especificaciones || [],
          });
        }
        grupos.get(clave).piezas += cantidadBuena;
      });
    });
    return [...grupos.values()].map((grupo) => {
      const unidadesMatriz = round2Decimals(grupo.piezas * grupo.porPieza);
      return {
        ...grupo,
        unidadesMatriz,
        insumos: grupo.especificaciones.map((esp) => ({
          insumoId: (esp.insumoId?._id || esp.insumoId)?.toString(),
          clave: esp.insumoId?.clave,
          descripcion: esp.insumoId?.descripcion,
          unidad: esp.insumoId?.unidadId?.nombre || "",
          porUnidad: esp.cantidad,
          necesario: round2Decimals((esp.cantidad || 0) * unidadesMatriz),
        })),
        especificaciones: undefined,
      };
    });
  };

  renderMaterialOcupado = () => {
    const ocupado = new Map();
    this.desgloseMovimientoPorMatriz().forEach((grupo) =>
      grupo.insumos.forEach((insumo) => {
        const previo = ocupado.get(insumo.insumoId) || { ...insumo, necesario: 0 };
        previo.necesario = round2Decimals(previo.necesario + insumo.necesario);
        ocupado.set(insumo.insumoId, previo);
      })
    );
    const lista = [...ocupado.values()].filter((insumo) => insumo.necesario > 0);
    if (lista.length === 0) return null;
    return (
      <Col span={24} style={{ marginBottom: 8 }}>
        <div style={{ padding: "8px 12px", borderRadius: 6, background: "#f6f8fa", borderLeft: "3px solid #8c8c8c", color: "#1a3a4a" }}>
          <div style={{ color: "#595959", marginBottom: 4 }}>Material que ocupas:</div>
          {lista.map((insumo) => (
            <div key={insumo.insumoId} style={{ display: "flex", justifyContent: "space-between", gap: 12, padding: "2px 0" }}>
              <span>{[insumo.clave, insumo.descripcion].filter(Boolean).join(" - ")}</span>
              <strong style={{ whiteSpace: "nowrap" }}>
                {insumo.necesario} {insumo.unidad}
              </strong>
            </div>
          ))}
        </div>
      </Col>
    );
  };

  calcularFaltantesDeMovimiento = () => {
    const { orden, inventarioOrden, sobrantesDisponibles } = this.state;
    if (!orden) return [];

    const insumosPorId = new Map();
    (orden.matrices || []).forEach((matriz) =>
      (matriz.especificaciones || []).forEach((esp) => {
        const id = (esp.insumoId?._id || esp.insumoId)?.toString();
        if (id) insumosPorId.set(id, esp.insumoId);
      })
    );

    const faltantes = [];
    insumosPorId.forEach((insumo, insumoId) => {
      const necesario = this.estimarCantidadInsumo(insumoId);
      if (necesario <= 0) return;

      const infoOrden = inventarioOrden.find((i) => i.insumoId === insumoId);
      const disponibleOrden = infoOrden?.disponible || 0;
      const faltante = round2Decimals(necesario - disponibleOrden);
      if (faltante <= 0) return;

      const libre = infoOrden?.inventarioProyecto || 0;
      const deLibre = round2Decimals(Math.min(faltante, libre));
      let porCubrir = round2Decimals(faltante - deLibre);

      const sobrantesUsados = [];
      (sobrantesDisponibles || [])
        .filter((s) => (s.insumoId?._id || s.insumoId)?.toString() === insumoId)
        .forEach((s) => {
          if (porCubrir <= 0) return;
          const usar = round2Decimals(Math.min(porCubrir, s.cantidadDisponible));
          if (usar > 0) {
            sobrantesUsados.push({ sobranteId: s._id, cantidad: usar, folioOrdenOrigen: s.folioOrdenOrigen });
            porCubrir = round2Decimals(porCubrir - usar);
          }
        });

      faltantes.push({
        insumoId,
        clave: insumo?.clave,
        descripcion: insumo?.descripcion,
        unidad: infoOrden?.unidad || "",
        necesario,
        disponibleOrden,
        faltante,
        deLibre,
        sobrantesUsados,
        sinCubrir: porCubrir,
      });
    });
    return faltantes;
  };

  onFinishFailedMover = (e) => ErrorItem(e);

  onFinishMover = () => {
    const { etapaOrigen, destinos, operadorId, maquinaria, minutosTrabajo, lotesPorInsumo } = this.state;

    const destinosValidos = destinos.filter((d) => d.etapaDestinoId && d.cantidad > 0);
    if (destinosValidos.length === 0) {
      MensajeError({ message: "Agrega al menos un destino con cantidad mayor a 0" });
      return;
    }
    if (destinosValidos.some((d) => !d.responsableId)) {
      MensajeError({ message: "Cada destino necesita un responsable asignado" });
      return;
    }

    const config = etapaOrigen.configuracionTransicion || {};
    if (config.pedirMaquinariaOperador && !operadorId && !maquinaria) {
      MensajeError({ message: `"${etapaOrigen.nombre}" exige asignar operador y/o maquinaria` });
      return;
    }
    if (config.pedirTiempoTrabajo && !minutosTrabajo) {
      MensajeError({ message: `"${etapaOrigen.nombre}" exige capturar el tiempo de trabajo` });
      return;
    }
    if (config.pedirLotes) {
      const faltantes = this.insumosConLotePorDestinos().filter((insumo) => {
        const sel = lotesPorInsumo[insumo._id];
        return !sel || (!sel.marbetes?.length && !sel.lotes?.length);
      });
      if (faltantes.length > 0) {
        MensajeError({ message: `Falta elegir lote/marbete de: ${faltantes.map((i) => i.clave || i.descripcion).join(", ")}` });
        return;
      }
    }

    const destinosConMotivos = new Set();
    for (const destino of destinosValidos) {
      const etapaDestino = this.state.etapas.find((e) => e._id === destino.etapaDestinoId);
      const configDestino = etapaDestino?.configuracionTransicion || {};
      if (this.motivosDeEtapa(destino.etapaDestinoId).length > 0) {
        if (destinosConMotivos.has(destino.etapaDestinoId)) {
          MensajeError({ message: `"${etapaDestino?.nombre}" solo puede ir una vez por movimiento; para mandar piezas con otro motivo haz otro movimiento` });
          return;
        }
        destinosConMotivos.add(destino.etapaDestinoId);
        if (!destino.motivoEntradaId) {
          MensajeError({ message: `Elige el motivo por el que las piezas entran a "${etapaDestino?.nombre}"` });
          return;
        }
      }
      if (configDestino.pedirValidacionCalidad && (!destino.calidadAprobadorId || !destino.calidadComentario)) {
        MensajeError({ message: `"${etapaDestino.nombre}" exige un responsable de calidad y su comentario para poder entrar` });
        return;
      }
      if (configDestino.pedirComentarioEntrada && !destino.comentarioEntrada) {
        MensajeError({ message: `"${etapaDestino.nombre}" exige un comentario para poder entrar` });
        return;
      }
      if (etapaDestino?.esDefectuoso && !destino.insumoScrapId) {
        MensajeError({ message: `"${etapaDestino.nombre}" exige elegir el insumo de scrap` });
        return;
      }
      if (etapaDestino?.esRetrabajo && !destino.insumoRetrabajoId) {
        MensajeError({ message: `"${etapaDestino.nombre}" exige elegir la matriz de retrabajo que se va a producir` });
        return;
      }
      if (etapaDestino?.esFinal && !destino.insumoTerminadoId) {
        MensajeError({ message: `"${etapaDestino.nombre}" exige elegir a qué insumo entra el producto terminado` });
        return;
      }
    }

    const faltantes = this.state.orden?.sinInventario ? [] : this.calcularFaltantesDeMovimiento();
    if (faltantes.length > 0) {
      this.setState({ modalConfirmarSobrantesMoverVisible: true, faltantesMover: faltantes, desgloseMover: this.desgloseMovimientoPorMatriz() });
      return;
    }

    this.ejecutarMoverPiezas([]);
  };

  cerrarModalConfirmarSobrantesMover = () => this.setState({ modalConfirmarSobrantesMoverVisible: false, faltantesMover: [] });

  ejecutarMoverPiezas = (usoSobrantes) => {
    const { etapaOrigen, destinos, operadorId, maquinaria, minutosTrabajo, lotesPorInsumo } = this.state;
    const destinosValidos = destinos.filter((d) => d.etapaDestinoId && d.cantidad > 0);

    this.setState({ loading: true, modalConfirmarSobrantesMoverVisible: false });
    axios
      .post(
        "ordenesDeProduccionPU/moverPiezas",
        {
          ordenId: this.ordenId,
          empresaId: this.props.empresaId,
          usuarioId: this.props.usuarioId,
          etapaOrigenId: etapaOrigen._id,
          operadorId,
          maquinaria,
          minutosTrabajo: unidadAMinutos(minutosTrabajo, this.props.unidadTiempoProduccion),
          lotesUtilizados: Object.entries(lotesPorInsumo).map(([insumoId, sel]) => ({ insumoId, marbetes: sel.marbetes, lotes: sel.lotes })),
          destinos: destinosValidos.map((d) => ({
            etapaDestinoId: d.etapaDestinoId,
            cantidad: d.cantidad,
            observaciones: d.observaciones,
            responsableId: d.responsableId,
            motivoEntradaId: d.motivoEntradaId || undefined,
            insumoScrapId: d.insumoScrapId,
            insumoRetrabajoId: d.insumoRetrabajoId,
            insumoTerminadoId: d.insumoTerminadoId,
            aprobacionCalidad: d.calidadAprobadorId ? { aprobadorId: d.calidadAprobadorId, comentario: d.calidadComentario } : undefined,
            comentarioEntrada: d.comentarioEntrada,
          })),
          usoSobrantes,
          fechaMovimiento: (this.state.fechaMovimiento || moment()).toDate(),
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success("Piezas movidas correctamente");
          NotificacionMovimientosInventario(res.data.movimientosIds);
          if (this.props.onMovido) this.props.onMovido();
          this.cerrarModalMover();
          this.setState((prev) => ({ recargarTrazabilidad: prev.recargarTrazabilidad + 1 }));
          this.cargarOrden();
          this.cargarInventarioOrden();
        } else {
          MensajeError({ message: res.data.error || "No se pudieron mover las piezas" });
        }
      })
      .catch(() => {
        this.setState({ loading: false });
        MensajeError({ message: "Error al conectar con el servidor" });
      });
  };

  renderAlertaConsumoExcedido() {
    const filas = this.comparativoMaterial().filter((f) => f.esMatriz && f.real > f.planeado);
    if (filas.length === 0) return null;
    return (
      <div
        style={{
          marginTop: 12,
          padding: "10px 14px",
          borderRadius: 8,
          backgroundColor: "#fffbe6",
          border: "1px solid #ffe58f",
        }}
      >
        <b style={{ color: "#ad6800" }}>
          Se consumió más material del planeado en {filas.length} matriz{filas.length === 1 ? "" : "ces"}:
        </b>
        <div style={{ marginTop: 6 }}>
          {filas.map((f) => (
            <Tag key={f.key} color="orange" style={{ marginBottom: 4 }}>
              {f.concepto} ({f.etapa?.nombre || "?"}): {f.real} de {f.planeado}
            </Tag>
          ))}
        </div>
      </div>
    );
  }

  destinosValidosDe = (etapa) => new Set((etapa?.transiciones || []).map((t) => (t.etapaDestinoId?._id || t.etapaDestinoId)?.toString()));

  estadoSoltarDe = (etapaId) => {
    const { etapaArrastradaId, etapaEncimaId, etapas } = this.state;
    if (!etapaArrastradaId) return null;
    if (etapaId === etapaArrastradaId) return "origen";
    const origen = etapas.find((e) => e._id === etapaArrastradaId);
    if (!this.destinosValidosDe(origen).has(etapaId?.toString())) return "invalida";
    return etapaEncimaId === etapaId ? "encima" : "valida";
  };

  onDragStart = ({ active }) => this.setState({ etapaArrastradaId: active.data.current?.etapaId || null, etapaEncimaId: null });

  onDragOver = ({ over }) => this.setState({ etapaEncimaId: over?.id || null });

  onDragCancel = () => this.setState({ etapaArrastradaId: null, etapaEncimaId: null });

  abrirMoverConTodo = (etapaOrigenId, etapaDestinoId) => {
    const { orden, etapas } = this.state;
    if (orden?.estado === 2 || !this.props.permisoMoverPiezasOrdenProduccionPU) return false;
    const origen = etapas.find((e) => e._id === etapaOrigenId);
    if (!origen || !etapaDestinoId || !this.destinosValidosDe(origen).has(etapaDestinoId.toString())) return false;
    const cantidad = this.cantidadEnEtapa(origen._id);
    if (cantidad <= 0) return false;
    this.abrirModalMover(origen, { etapaDestinoId, cantidad });
    return true;
  };

  abrirMovimientoSolicitado = () => {
    const { location, history, moverInicial } = this.props;
    if (moverInicial) {
      if (this.moverInicialAbierto) return;
      this.moverInicialAbierto = true;
      if (!this.abrirMoverConTodo(moverInicial.etapaOrigenId, moverInicial.etapaDestinoId) && this.props.onCerrarEmbebido) this.props.onCerrarEmbebido();
      return;
    }
    const mover = location?.state?.mover;
    if (!mover) return;
    history.replace(location.pathname, { ...location.state, mover: undefined });
    this.abrirMoverConTodo(mover.etapaOrigenId, mover.etapaDestinoId);
  };

  onDragEnd = ({ active, over }) => {
    this.setState({ etapaArrastradaId: null, etapaEncimaId: null });
    this.abrirMoverConTodo(active.data.current?.etapaId, over?.id);
  };

  renderTablero() {
    const { etapas, orden } = this.state;
    const esMobile = window.innerWidth <= 1000;
    const cancelada = orden?.estado === 2 || !this.props.permisoMoverPiezasOrdenProduccionPU;

    if (esMobile) {
      return (
        <Row gutter={[16, 16]}>
          {etapas.map((etapa) => (
            <Col span={24} key={etapa._id}>
              <ColumnaEtapaOrdenPU
                etapa={etapa}
                cantidad={this.cantidadEnEtapa(etapa._id)}
                renglonesConsumo={this.renglonesConsumoDeEtapa(etapa._id)}
                enviados={this.enviadosARetrabajo(etapa)}
                producto={this.productoDeOrden()}
                piezasPasadas={this.piezasPasadasPorEtapa(etapa)}
                cantidadEsperada={orden?.cantidadEsperada || 0}
                deshabilitado={cancelada}
                esAbierta={orden?.tipoLista === "abierta"}
                onMoverPiezas={this.abrirModalMover}
                onSolicitarMaterial={this.state.orden?.sinInventario ? undefined : (renglones) => this.abrirConfirmarSolicitar(etapa, renglones)}
                anchoCompleto
              />
            </Col>
          ))}
        </Row>
      );
    }

    const etapaArrastrada = etapas.find((e) => e._id === this.state.etapaArrastradaId);

    return (
      <DndContext
        sensors={SENSORES_TABLERO}
        collisionDetection={pointerWithin}
        onDragStart={this.onDragStart}
        onDragOver={this.onDragOver}
        onDragEnd={this.onDragEnd}
        onDragCancel={this.onDragCancel}
      >
        <div className="tablero-scroll-x" style={{ display: "flex", overflowX: "auto", gap: 12, paddingBottom: 10 }}>
          {etapas.map((etapa) => (
            <ColumnaEtapaOrdenPUArrastrable
              key={etapa._id}
              estadoSoltar={this.estadoSoltarDe(etapa._id)}
            etapa={etapa}
            cantidad={this.cantidadEnEtapa(etapa._id)}
            renglonesConsumo={this.renglonesConsumoDeEtapa(etapa._id)}
            enviados={this.enviadosARetrabajo(etapa)}
            producto={this.productoDeOrden()}
            piezasPasadas={this.piezasPasadasPorEtapa(etapa)}
            cantidadEsperada={orden?.cantidadEsperada || 0}
            deshabilitado={cancelada}
            esAbierta={orden?.tipoLista === "abierta"}
            onMoverPiezas={this.abrirModalMover}
            onSolicitarMaterial={this.state.orden?.sinInventario ? undefined : (renglones) => this.abrirConfirmarSolicitar(etapa, renglones)}
            />
          ))}
        </div>
        {createPortal(
          <DragOverlay dropAnimation={null}>
            {etapaArrastrada ? (
              <TarjetaProductoEtapaPU
                color={colorDeEtapa(etapaArrastrada)}
                producto={this.productoDeOrden()}
                piezasPasadas={this.piezasPasadasPorEtapa(etapaArrastrada)}
                cantidadEsperada={orden?.cantidadEsperada || 0}
                style={{ width: 260, cursor: "grabbing", boxShadow: "0 8px 20px rgba(0,0,0,0.18)" }}
              >
                <div style={{ marginTop: 6, fontSize: 11, fontWeight: 600, color: colorDeEtapa(etapaArrastrada) }}>{this.cantidadEnEtapa(etapaArrastrada._id)} pzs</div>
              </TarjetaProductoEtapaPU>
            ) : null}
          </DragOverlay>,
          document.body
        )}
      </DndContext>
    );
  }

  render() {
    const { orden, etapas, etapaOrigen, destinos } = this.state;

    if (!this.ordenId) {
      return <Alert type="error" message="No se especificó qué orden de producción ver" />;
    }

    const configOrigen = etapaOrigen?.configuracionTransicion || {};
    const insumosConLote = this.insumosConLotePorDestinos();
    const cantidadTotalDestinos = this.cantidadTotalDestinos();

    return (
      <Spin spinning={this.state.loading}>
        {!this.props.soloMover && (
        <>
        <PageHeader
          title={orden ? `Orden ${orden.folio}` : this.props.ordenesMaquila ? "Orden de maquila" : "Orden de producción"}
          onBack={() => this.props.history.goBack()}
          backIcon={<ArrowLeftOutlined />}
          style={{ border: "1px solid rgb(235, 237, 240)", backgroundColor: "white", marginBottom: 10 }}
          extra={[<BotonAyudaManuales key="manuales" modulo="ordenesProduccionPU" />]}
        />

        <div style={{ backgroundColor: "white", borderRadius: 12, padding: 20, boxShadow: "0 2px 8px rgba(0, 0, 0, 0.06)" }}>
          {orden && (
            <>
              <Row gutter={[16, 16]} style={{ marginBottom: 8 }}>
                <DynamicCardForm
                  span={24}
                  title="Datos de la orden"
                  compact
                  headerRight={
                    <Row gutter={8}>
                      {orden.presupuestoPUId?._id && (
                        <Col>
                          <ButtonItem
                            siena
                            size="small"
                            onClick={() => this.props.history.push("/panel/presupuestoPU", { id: orden.presupuestoPUId?._id })}
                          >
                            Ver presupuesto de origen
                          </ButtonItem>
                        </Col>
                      )}
                      {orden.modoMaquila && (
                        <Col>
                          <ButtonItem cyan size="small" icon={<FilePdfOutlined />} onClick={() => this.setState({ modalPdfMaquilaVisible: true })}>
                            Ver PDF
                          </ButtonItem>
                        </Col>
                      )}
                      {this.props.permisoCancelarOrdenProduccionPU &&
                        orden.estado === 1 &&
                        !orden.consumos.some((c) => c.consumido > 0) && (
                          <Col>
                            <ButtonItem type="default" danger size="small" icon={<StopOutlined />} onClick={this.abrirModalCancelar}>
                              Cancelar orden
                            </ButtonItem>
                          </Col>
                        )}
                      {this.props.permisoTerminarOrdenProduccionPU && orden.estado === 1 && (
                        <Col>
                          <ButtonItem lima size="small" icon={<CheckCircleOutlined />} onClick={this.terminarOrden}>
                            Terminar orden
                          </ButtonItem>
                        </Col>
                      )}
                      {orden.estado === 3 && (
                        <Col>
                          <ButtonItem
                            cyan
                            size="small"
                            icon={<FilePdfOutlined />}
                            onClick={() => this.setState({ modalPdfCierreVisible: true })}
                          >
                            Ver PDF de cierre
                          </ButtonItem>
                        </Col>
                      )}
                      {this.props.permisoReabrirOrdenProduccionPU &&
                        orden.estado === 3 &&
                        !orden.consumos.some((c) => c.consumido > 0) && (
                          <Col>
                            <ButtonItem naranja size="small" icon={<UndoOutlined />} onClick={this.abrirModalReabrir}>
                              Reabrir orden
                            </ButtonItem>
                          </Col>
                        )}
                    </Row>
                  }
                >
                  <Row gutter={[12, 8]}>
                    <Col span={24} lg={12}>
                      <div style={{ fontSize: 14, color: "#555", marginBottom: 5, lineHeight: 1.5 }}>
                        <span style={{ fontWeight: 600, color: "#333" }}>Flujo de producción: </span>
                        {orden.flujoId?.nombre || "—"}
                      </div>
                      {orden.presupuestoPUId?.nombre ? (
                        <>
                          <div style={{ fontSize: 14, color: "#555", marginBottom: 5, lineHeight: 1.5 }}>
                            <span style={{ fontWeight: 600, color: "#333" }}>Presupuesto: </span>
                            {orden.presupuestoPUId.nombre}
                          </div>
                          <div style={{ fontSize: 14, color: "#555", marginBottom: 5, lineHeight: 1.5 }}>
                            <span style={{ fontWeight: 600, color: "#333" }}>Partida: </span>
                            {orden.partidaSnapshot?.nombre || "—"}
                          </div>
                        </>
                      ) : (
                        <div style={{ fontSize: 14, color: "#555", marginBottom: 5, lineHeight: 1.5 }}>
                          <span style={{ fontWeight: 600, color: "#333" }}>Origen: </span>
                          Matriz
                        </div>
                      )}
                      <div style={{ fontSize: 14, color: "#555", marginBottom: 5, lineHeight: 1.5 }}>
                        <span style={{ fontWeight: 600, color: "#333" }}>Cantidad esperada: </span>
                        {orden.cantidadEsperada}
                      </div>
                      <div style={{ fontSize: 14, color: "#555", marginBottom: 5, lineHeight: 1.5 }}>
                        <span style={{ fontWeight: 600, color: "#333" }}>Cantidad final (a Terminado): </span>
                        {orden.cantidadFinal}
                      </div>
                    </Col>
                    <Col span={24} lg={12}>
                      <div style={{ fontSize: 14, color: "#555", marginBottom: 5, lineHeight: 1.5 }}>
                        <span style={{ fontWeight: 600, color: "#333" }}>Tipo de lista: </span>
                        {orden.tipoLista === "abierta" ? "Abierta" : "Cerrada"}
                      </div>
                      <div style={{ fontSize: 14, color: "#555", marginBottom: 5, lineHeight: 1.5 }}>
                        <span style={{ fontWeight: 600, color: "#333" }}>Proyecto de ejecución: </span>
                        {orden.proyectoEjecucionId?.nombre || "—"}
                      </div>
                      <div style={{ fontSize: 14, color: "#555", marginBottom: 5, lineHeight: 1.5 }}>
                        <span style={{ fontWeight: 600, color: "#333" }}>Proyecto de origen: </span>
                        {orden.proyectoOrigenId?.nombre || "Ya estaba en ejecución"}
                      </div>
                    </Col>
                    {(orden.estado === 2 || orden.estado === 3) && (
                      <Col span={24}>
                        {orden.estado === 2 && (
                          <Tag color="red" style={{ marginBottom: 8 }}>
                            Cancelada{orden.motivoCancelacion ? ` -- ${orden.motivoCancelacion}` : ""}
                          </Tag>
                        )}
                        {orden.estado === 3 && (
                          <Tag color="green" style={{ marginBottom: 8 }}>
                            Terminada
                          </Tag>
                        )}
                      </Col>
                    )}
                  </Row>
                </DynamicCardForm>
              </Row>

              <TabbedDynamicTable
                defaultActiveKey="tablero"
                showContentBorder={false}
                tabs={[
                  {
                    key: "tablero",
                    label: "Tablero",
                    customContent: (
                      <>
                        {this.renderTablero()}

                        {this.renderAlertaConsumoExcedido()}

                        <Divider orientation="left" plain style={{ margin: "24px 0 8px 0" }}>
                          Real vs. planeado
                        </Divider>
                        <Table
                          size="small"
                          pagination={false}
                          rowKey="key"
                          dataSource={this.comparativoMaterial()}
                          locale={{ emptyText: "Sin material que comparar" }}
                          defaultExpandAllRows
                          columns={[
                            {
                              title: "Matriz / insumo",
                              dataIndex: "concepto",
                              key: "concepto",
                              render: (valor, fila) => (fila.esMatriz ? <b>{valor}</b> : valor),
                            },
                            {
                              title: "Etapa",
                              key: "etapa",
                              width: 160,
                              render: (_, fila) =>
                                fila.esMatriz && fila.etapa ? (
                                  <span
                                    style={{
                                      display: "inline-flex",
                                      alignItems: "center",
                                      gap: 4,
                                      border: `1px solid ${colorDeEtapa(fila.etapa)}`,
                                      color: colorDeEtapa(fila.etapa),
                                      borderRadius: 12,
                                      padding: "1px 10px",
                                      fontSize: 12,
                                    }}
                                  >
                                    {iconoDeEtapa(fila.etapa)} {fila.etapa.nombre}
                                  </span>
                                ) : (
                                  ""
                                ),
                            },
                            { title: "Unidad", dataIndex: "unidad", key: "unidad", width: 100, render: (valor) => valor || "—" },
                            {
                              title: "Por matriz",
                              dataIndex: "porUnidad",
                              key: "porUnidad",
                              width: 100,
                              align: "right",
                              render: (valor) => (valor === undefined ? "—" : valor),
                            },
                            {
                              title: "Planeado",
                              dataIndex: "planeado",
                              key: "planeado",
                              width: 120,
                              align: "right",
                              render: (valor, fila) => (fila.esMatriz ? <b>{valor}</b> : valor),
                            },
                            {
                              title: "Consumido",
                              key: "real",
                              width: 150,
                              align: "right",
                              render: (_, fila) =>
                                fila.esMatriz ? (
                                  <b style={{ color: fila.real > fila.planeado ? "#ff4d4f" : "inherit" }}>
                                    {fila.real} de {fila.planeado}
                                  </b>
                                ) : (
                                  fila.real
                                ),
                            },
                            ...(orden.modoMaquila
                              ? []
                              : [
                                  {
                                    title: "Merma",
                                    dataIndex: "merma",
                                    key: "merma",
                                    width: 100,
                                    align: "right",
                                    render: (valor) =>
                                      valor === undefined ? "—" : valor > 0 ? <span style={{ color: "#ff4d4f" }}>{valor}</span> : "—",
                                  },
                                ]),
                            {
                              title: "Diferencia",
                              dataIndex: "diferencia",
                              key: "diferencia",
                              width: 120,
                              align: "right",
                              render: (value) => <span style={{ color: value < 0 ? "#ff4d4f" : value > 0 ? "#faad14" : "#52c41a" }}>{value}</span>,
                            },
                          ]}
                        />
                      </>
                    ),
                  },
                  ...(orden.sinInventario ? [] : [{
                    key: "inventarioOrden",
                    label: "Inventario de la orden",
                    customContent: (
                      <>
                        <div style={{ color: "#999", fontSize: 12, marginBottom: 12 }}>
                          "Requisitado" es lo que ya se le pidió a Almacén para esta orden y puede seguir sin llegar. "Traspasado" ya es
                          material físicamente movido a esta orden. "Disponible" = Traspasado - Consumido. "En inventario del proyecto" ya
                          descuenta lo que otras órdenes de producción activas del mismo proyecto tienen reservado (traspasado y sin
                          consumir todavía) -- si aun así queda algo, es lo que de verdad está libre para esta orden.
                        </div>
                        <Table
                          size="small"
                          pagination={false}
                          rowKey="insumoId"
                          dataSource={this.state.inventarioOrden}
                          locale={{ emptyText: "Sin movimientos de material para esta orden" }}
                          columns={[
                            {
                              title: "Insumo",
                              key: "insumo",
                              render: (_, fila) => `${fila.clave ? fila.clave + " - " : ""}${fila.descripcion}`,
                            },
                            { title: "Unidad", dataIndex: "unidad", key: "unidad", width: 100, render: (valor) => valor || "—" },
                            { title: "Requisitado", dataIndex: "requisitado", key: "requisitado", width: 120, align: "right" },
                            { title: "Traspasado", dataIndex: "traspasado", key: "traspasado", width: 120, align: "right" },
                            { title: "Consumido", dataIndex: "consumido", key: "consumido", width: 120, align: "right" },
                            {
                              title: "Disponible",
                              dataIndex: "disponible",
                              key: "disponible",
                              width: 120,
                              align: "right",
                              render: (valor) => <span style={{ color: valor < 0 ? "#ff4d4f" : "#52c41a" }}>{valor}</span>,
                            },
                            {
                              title: (
                                <Tooltip title="Ya descuenta lo reservado (traspasado y sin consumir) por otras órdenes de producción activas del mismo proyecto.">
                                  En inventario del proyecto
                                </Tooltip>
                              ),
                              dataIndex: "inventarioProyecto",
                              key: "inventarioProyecto",
                              width: 150,
                              align: "right",
                              render: (valor) => (valor > 0 ? <span style={{ color: "#1890ff" }}>{valor}</span> : valor ?? 0),
                            },
                          ]}
                        />
                      </>
                    ),
                  }]),
                  {
                    key: "trazabilidad",
                    label: "Trazabilidad",
                    customContent: (
                      <TrazabilidadOrdenPU
                        ordenId={this.ordenId}
                        recargar={this.state.recargarTrazabilidad}
                        puedeCancelar={this.props.puedeCancelarMovimiento && this.state.orden?.estado === 1}
                        onCambio={() => {
                          this.cargarOrden();
                          this.cargarInventarioOrden();
                        }}
                      />
                    ),
                  },
                ]}
              />
            </>
          )}
        </div>
        </>
        )}

        <ModalItem
          title={`Mover piezas desde "${etapaOrigen?.nombre || ""}"`}
          visible={this.state.modalMoverVisible}
          spinning={this.state.loading}
          onCancel={this.cerrarModalMover}
          width="80%"
          paddingTop
        >
          <Form
            name="MoverPiezasOrdenProduccionPU"
            layout
            bottom={
              <ButtonItem type="primary" htmlType="submit" style={{ display: "block", margin: "0 0 0 auto" }}>
                Mover
              </ButtonItem>
            }
            onFinish={this.onFinishMover}
            onFinishFailed={this.onFinishFailedMover}
          >
            <Row gutter={16} style={{ width: "100%" }}>
              <Col span={24} style={{ marginBottom: 8 }}>
                <div style={{ padding: "8px 12px", borderRadius: 6, background: "#e6fffb", borderLeft: "3px solid #00BFD6", color: "#1a3a4a" }}>
                  <span style={{ color: "#595959" }}>Pieza que se mueve: </span>
                  <strong>{this.piezasQueSeMueven()}</strong>
                </div>
              </Col>
              {this.state.orden?.sinInventario && this.renderMaterialOcupado()}
              <Col span={24} style={{ marginBottom: 8, color: "#999", fontSize: 12 }}>
                Disponibles en "{etapaOrigen?.nombre}": {this.cantidadEnEtapa(etapaOrigen?._id)} -- repartidas hasta ahora: {cantidadTotalDestinos}
              </Col>
              <Col span={10} style={{ marginBottom: 12 }}>
                <FormItem
                  label="Hora de movimiento"
                  required
                  margin
                  labelCol={{ span: 24 }}
                  wrapperCol={{ span: 24 }}
                  tooltip="Por defecto es la hora actual. Si el movimiento se hizo antes, cámbiala; también se guarda la hora en que se registró."
                >
                  <DatePickerItem
                    style={{ width: "100%" }}
                    allowClear={false}
                    showTime={{ format: "HH:mm" }}
                    format="DD/MM/YYYY HH:mm"
                    inputReadOnly
                    value={this.state.fechaMovimiento}
                    disabledDate={(d) => d && d.isAfter(moment(), "day")}
                    onSelect={(fechaMovimiento) => this.setState({ fechaMovimiento })}
                    onChange={(fechaMovimiento) => fechaMovimiento && this.setState({ fechaMovimiento })}
                  />
                </FormItem>
              </Col>

              {(configOrigen.pedirMaquinariaOperador || configOrigen.pedirTiempoTrabajo) && (
                <Col span={24}>
                  <div style={{ border: "1px solid #f0f0f0", borderRadius: 8, padding: "12px 12px 0 12px", marginBottom: 16, backgroundColor: "#fafafa" }}>
                    <div style={{ fontWeight: 600, marginBottom: 8 }}>
                      <ToolOutlined style={{ marginRight: 6, color: "#1890ff" }} />
                      Datos de salida de "{etapaOrigen?.nombre}"
                    </div>
                    <Row gutter={16}>
                      {configOrigen.pedirMaquinariaOperador && (
                        <>
                          <Col span={8}>{this.renderUsuarioActual("Operador")}</Col>
                          <Col span={8}>
                            <FormItem label="Maquinaria" margin labelCol={{ span: 24 }} wrapperCol={{ span: 24 }} tooltip="Texto libre para indicar la maquinaria utilizada (ej. 'Prensa 1', 'Cortadora láser', etc.)   ">
                              <InputItem value={this.state.maquinaria} onChange={(e) => this.setState({ maquinaria: e.target.value })} placeholder="Opcional" />
                            </FormItem>
                          </Col>
                        </>
                      )}
                      {configOrigen.pedirTiempoTrabajo && (
                        <Col span={8}>
                          <FormItem
                            label={this.props.unidadTiempoProduccion === "horas" ? "Horas de trabajo" : "Minutos de trabajo"}
                            required
                            margin
                            labelCol={{ span: 24 }}
                            wrapperCol={{ span: 24 }}
                            tooltip={`Tiempo total que tomó todo este movimiento -- se aplica una sola vez a "${etapaOrigen?.nombre}", no se reparte entre los destinos ni por pieza.`}
                          >
                            <InputNumberItem style={{ width: "100%" }} min={this.props.unidadTiempoProduccion === "horas" ? 0.01 : 1} value={this.state.minutosTrabajo} onChange={(minutosTrabajo) => this.setState({ minutosTrabajo })} />
                          </FormItem>
                        </Col>
                      )}
                    </Row>
                  </div>
                </Col>
              )}

              {configOrigen.pedirLotes && insumosConLote.length > 0 && (
                <Col span={24}>
                  <div style={{ fontWeight: 600, marginBottom: 8 }}>
                    <span style={{ color: "#ff4d4f", marginRight: 4 }}>*</span>Lotes/marbetes de materia prima
                  </div>
                  {insumosConLote.map((insumo) => {
                    const seleccion = this.state.lotesPorInsumo[insumo._id];
                    const elegido = seleccion?.marbetes?.length || seleccion?.lotes?.length;
                    return (
                      <Row key={insumo._id} align="middle" gutter={8} style={{ marginBottom: 8 }}>
                        <Col span={12}>
                          {insumo.clave} - {insumo.descripcion}
                        </Col>
                        <Col span={12}>
                          <ButtonItem size="small" cyan={!elegido} lima={!!elegido} onClick={() => this.abrirElegirLote(insumo)}>
                            {elegido ? "Lote/marbete elegido ✓" : "Elegir lote/marbete"}
                          </ButtonItem>
                        </Col>
                      </Row>
                    );
                  })}
                  <Divider style={{ margin: "8px 0" }} />
                </Col>
              )}

              <Col span={24}>
                <div style={{ fontWeight: 600, marginBottom: 4 }}>Destinos</div>
                <div style={{ color: "#999", fontSize: 12, marginBottom: 8 }}>
                  Reparte lo que sale de "{etapaOrigen?.nombre}" en uno o varios destinos (ej. de 20: 18 a Terminado, 2 a Retrabajo).
                </div>
                {destinos.map((destino, index) => {
                  const etapaDestino = etapas.find((e) => e._id === destino.etapaDestinoId);
                  const configDestino = etapaDestino?.configuracionTransicion || {};
                  return (
                    <div key={index} style={{ border: "1px solid #f0f0f0", borderRadius: 8, padding: "12px 12px 0 12px", marginBottom: 12, backgroundColor: "#fafafa" }}>
                      <Row gutter={16}>
                        <Col span={8}>
                          <FormItem label="Etapa destino" required margin labelCol={{ span: 24 }} wrapperCol={{ span: 24 }}>
                            <Select
                              placeholder="Etapa destino"
                              style={{ width: "100%" }}
                              value={destino.etapaDestinoId || undefined}
                              onChange={(etapaDestinoId) => this.cambiarDestino(index, { etapaDestinoId, motivoEntradaId: null })}
                            >
                              {(etapaOrigen?.transiciones || []).map((t) => {
                                const destinoId = t.etapaDestinoId?._id || t.etapaDestinoId;
                                const etapaCompleta = etapas.find((e) => e._id === destinoId) || t.etapaDestinoId;
                                const nombreDestino = etapaCompleta?.nombre || "Etapa";
                                return (
                                  <Option key={destinoId} value={destinoId}>
                                    <span style={{ color: colorDeEtapa(etapaCompleta), marginRight: 6 }}>{iconoDeEtapa(etapaCompleta)}</span>
                                    <span style={{ fontWeight: 600 }}>{nombreDestino}</span>
                                    {t.etiqueta && <span style={{ color: "#8c8c8c" }}> — {t.etiqueta}</span>}
                                  </Option>
                                );
                              })}
                            </Select>
                          </FormItem>
                        </Col>
                        <Col span={6}>
                          <FormItem label="Cantidad" required margin labelCol={{ span: 24 }} wrapperCol={{ span: 24 }}>
                            <InputNumberItem
                              style={{ width: "100%" }}
                              min={1}
                              placeholder="Cantidad"
                              value={destino.cantidad}
                              onChange={(cantidad) => this.cambiarDestino(index, { cantidad })}
                            />
                          </FormItem>
                        </Col>
                        <Col span={8}>
                          <FormItem label="Observaciones" margin labelCol={{ span: 24 }} wrapperCol={{ span: 24 }}>
                            <InputItem
                              placeholder="Opcional"
                              value={destino.observaciones}
                              onChange={(e) => this.cambiarDestino(index, { observaciones: e.target.value })}
                            />
                          </FormItem>
                        </Col>
                        <Col span={2} style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                          <ButtonItem type="default" rojo size="small" icon={<DeleteOutlined />} onClick={() => this.eliminarDestino(index)} />
                        </Col>
                      </Row>

                      <Row gutter={16}>
                        <Col span={12}>
                          {this.renderUsuarioActual(`Responsable en "${etapaDestino?.nombre || "esta etapa"}"`)}
                        </Col>
                        {this.motivosDeEtapa(destino.etapaDestinoId).length > 0 && (
                          <Col span={12}>
                            <FormItem label={`Motivo de entrada a "${etapaDestino?.nombre}"`} required margin labelCol={{ span: 24 }} wrapperCol={{ span: 24 }}>
                              <SelectItem
                                placeholder="¿Por qué van a esta etapa?"
                                width="100%"
                                value={destino.motivoEntradaId || undefined}
                                onChange={(motivoEntradaId) => this.cambiarDestino(index, { motivoEntradaId })}
                              >
                                {this.motivosDeEtapa(destino.etapaDestinoId).map((motivo) => (
                                  <Option key={motivo._id} value={motivo._id}>
                                    {`${motivo.orden}. ${motivo.nombre}`}
                                  </Option>
                                ))}
                              </SelectItem>
                            </FormItem>
                          </Col>
                        )}
                      </Row>

                      {etapaDestino?.esDefectuoso && (
                        <Row gutter={16}>
                          <Col span={24}>
                            <FormItem
                              label="Insumo de scrap"
                              required
                              margin
                              labelCol={{ span: 24 }}
                              wrapperCol={{ span: 24 }}
                              tooltip="Las piezas defectuosas se dan de alta en inventario contra este insumo, con el costo acumulado del lote."
                            >
                              {this.renderInsumoConDefault(index, destino, "insumoScrapId", this.state.defaultsProduccion.insumoScrap, {
                                tiposInsumos: "inventariables",
                                placeholder: "Elige el insumo al que se da de alta el scrap",
                              })}
                            </FormItem>
                          </Col>
                        </Row>
                      )}

                      {etapaDestino?.esRetrabajo && (
                        <Row gutter={16}>
                          <Col span={24}>
                            <FormItem
                              label="Matriz de retrabajo"
                              required
                              margin
                              labelCol={{ span: 24 }}
                              wrapperCol={{ span: 24 }}
                              tooltip="Las piezas se juntarán con otras en una orden de retrabajo de esta matriz."
                            >
                              {this.renderInsumoConDefault(index, destino, "insumoRetrabajoId", this.state.defaultsProduccion.matrizRetrabajo, {
                                tiposInsumos: "matrices",
                                placeholder: "Elige la matriz que se produce en el retrabajo",
                              })}
                            </FormItem>
                          </Col>
                        </Row>
                      )}

                      {etapaDestino?.esFinal && (
                        <Row gutter={16}>
                          <Col span={24}>
                            <FormItem
                              label="Insumo del producto terminado"
                              required
                              margin
                              labelCol={{ span: 24 }}
                              wrapperCol={{ span: 24 }}
                              tooltip="A este insumo entra el producto que sale de la orden, con el costo acumulado del lote."
                            >
                              {this.renderInsumoConDefault(index, destino, "insumoTerminadoId", this.state.defaultsProduccion.insumoTerminado, {
                                tiposInsumos: "inventariables",
                                placeholder: "Elige el insumo que se produce",
                              })}
                            </FormItem>
                          </Col>
                        </Row>
                      )}

                      {configDestino.pedirValidacionCalidad && (
                        <Row gutter={16}>
                          <Col span={8}>
                            <FormItem label="Responsable de calidad" margin labelCol={{ span: 24 }} wrapperCol={{ span: 24 }}>
                              <InputItem disabled value={this.props.nombreUsuario} />
                            </FormItem>
                          </Col>
                          <Col span={16}>
                            <FormItem label="Comentario de calidad" required margin labelCol={{ span: 24 }} wrapperCol={{ span: 24 }}>
                              <TextAreaItem
                                placeholder="Comentario de calidad"
                                autoSize={{ minRows: 1, maxRows: 4 }}
                                value={destino.calidadComentario}
                                onChange={(e) => this.cambiarDestino(index, { calidadComentario: e.target.value })}
                              />
                            </FormItem>
                          </Col>
                        </Row>
                      )}

                      {configDestino.pedirComentarioEntrada && (
                        <Row gutter={16}>
                          <Col span={24}>
                            <FormItem label="Comentario de entrada" required margin labelCol={{ span: 24 }} wrapperCol={{ span: 24 }}>
                              <InputItem
                                placeholder="Comentario"
                                value={destino.comentarioEntrada}
                                onChange={(e) => this.cambiarDestino(index, { comentarioEntrada: e.target.value })}
                              />
                            </FormItem>
                          </Col>
                        </Row>
                      )}
                    </div>
                  );
                })}
                <ButtonItem lila icon={<PlusOutlined />} size="small" onClick={this.agregarDestino}>
                  Agregar destino
                </ButtonItem>
              </Col>
            </Row>
          </Form>
        </ModalItem>

        {this.state.modalElegirTipo === "marbetes" && (
          <ElegirMarbetes
            visible={this.state.modalElegirVisible}
            cerrarElegirMarbetes={this.cerrarElegirLote}
            marbetes={this.state.insumoActivo ? this.state.lotesPorInsumo[this.state.insumoActivo._id]?.marbetes : undefined}
            insumoId={this.state.insumoActivo?._id}
            proyectoId={this.state.orden?.proyectoEjecucionId?._id}
          />
        )}
        {this.state.modalElegirTipo === "lotes" && (
          <ElegirLotes
            visible={this.state.modalElegirVisible}
            cerrarElegirLotes={this.cerrarElegirLote}
            lotes={this.state.insumoActivo ? this.state.lotesPorInsumo[this.state.insumoActivo._id]?.lotes : undefined}
            insumoId={this.state.insumoActivo?._id}
            proyectoId={this.state.orden?.proyectoEjecucionId?._id}
            cantidad={this.state.insumoActivo ? this.estimarCantidadInsumo(this.state.insumoActivo._id) : undefined}
          />
        )}

        <ModalCancelarOrdenPU
          visible={this.state.modalCancelarVisible}
          ordenId={this.ordenId}
          onCerrar={this.cerrarModalCancelar}
          onCancelada={this.onOrdenCancelada}
        />

        <ModalReabrirOrdenPU
          visible={this.state.modalReabrirVisible}
          ordenId={this.ordenId}
          onCerrar={this.cerrarModalReabrir}
          onReabierta={this.onOrdenReabierta}
        />

        <ModalPdfOrdenMaquila
          visible={!!this.state.modalPdfMaquilaVisible}
          ordenId={this.ordenId}
          onCancel={() => this.setState({ modalPdfMaquilaVisible: false })}
        />

        <ModalPdfCierreOrdenPU
          visible={this.state.modalPdfCierreVisible}
          ordenId={this.ordenId}
          onCancel={this.cerrarModalPdfCierre}
        />

        <ModalConfirmarSolicitarMaterialPU
          visible={this.state.modalSolicitarVisible}
          etapa={this.state.solicitarEtapa}
          pendientes={this.state.solicitarPendientes}
          insumosPorMatriz={this.state.solicitarInsumosPorMatriz}
          cantidadesEditadas={this.state.solicitarCantidadesEditadas}
          cantidadAProducir={this.state.solicitarCantidadAProducir}
          insumosCargando={this.state.solicitarInsumosCargando}
          observaciones={this.state.solicitarObservaciones}
          loading={this.state.loading}
          esAbierta={this.state.orden?.tipoLista === "abierta"}
          insumosExtra={this.state.solicitarInsumosExtra}
          empresaId={this.props.empresaId}
          headersToken={this.props.headersToken}
          onChangeInsumosExtra={(solicitarInsumosExtra) => this.setState({ solicitarInsumosExtra })}
          onChangeObservaciones={(observaciones) => this.setState({ solicitarObservaciones: observaciones })}
          onChangeCantidadInsumo={this.onChangeCantidadInsumoSolicitar}
          onChangeCantidadAProducir={this.recalcularCantidadesSolicitar}
          onCerrar={this.cerrarConfirmarSolicitar}
          onConfirmar={this.confirmarSolicitarTodoDeEtapa}
        />

        <ModalSobrantesCierreOrdenPU
          visible={this.state.modalSobrantesVisible}
          sobrantes={this.state.sobrantesPendientes}
          onCerrar={this.cerrarModalSobrantes}
          onConfirmar={this.confirmarCierreOrden}
        />

        <ModalConfirmarSobrantesMoverPU
          visible={this.state.modalConfirmarSobrantesMoverVisible}
          faltantes={this.state.faltantesMover}
          desglose={this.state.desgloseMover}
          puedeUsarSobrantes={this.props.permisoUsarSobrantesProduccionPU}
          onCerrar={this.cerrarModalConfirmarSobrantesMover}
          onConfirmar={this.ejecutarMoverPiezas}
        />
      </Spin>
    );
  }
}

const mapStateToProps = (state) => ({
  unidadTiempoProduccion: state.empresa.unidadTiempoProduccion,
  ordenesMaquila: state.empresa.ordenesMaquila,
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
  usuarioId: state.user.usuarioId,
  nombreUsuario:
    [state.user.nombre, state.user.apellidoPaterno, state.user.apellidoMaterno].filter(Boolean).join(" ") ||
    state.user.nombre ||
    "",
  puedeCancelarMovimiento:
    state.user.tipo === 0 ||
    !!state.user.permisos.find((v) => v.permisoId.toString() === "6aa32898a540d9e36417b059")?.activado,
  permisoCancelarOrdenProduccionPU:
    state.user.tipo === 0 ||
    !!state.user.permisos.find((v) => v.permisoId.toString() === "6a9b304d52b97b73c85edc28")?.activado,
  permisoMoverPiezasOrdenProduccionPU:
    state.user.tipo === 0 ||
    !!state.user.permisos.find((v) => v.permisoId.toString() === "6a9b305e52b97b73c85edd94")?.activado,
  permisoTerminarOrdenProduccionPU:
    state.user.tipo === 0 ||
    !!state.user.permisos.find((v) => v.permisoId.toString() === "6aa328bf3d2dd25d76ace2a6")?.activado,
  permisoReabrirOrdenProduccionPU:
    state.user.tipo === 0 ||
    !!state.user.permisos.find((v) => v.permisoId.toString() === "6aa328cc3d2dd25d76ace2bc")?.activado,
  permisoUsarSobrantesProduccionPU:
    state.user.tipo === 0 ||
    !!state.user.permisos.find((v) => v.permisoId.toString() === "6aa07809ee88a932beb9fcb4")?.activado,
  ocultarCostosOrdenProduccionPU:
    state.user.tipo !== 0 &&
    !state.user.permisos.find((v) => v.permisoId.toString() === "6aa99cc1341d44e893c47cdd")?.activado,
});

export default connect(mapStateToProps)(VistaOrdenDeProduccionPU);
